export type VrLineHeight = { [key: string]: number };

export type VrSet = { [key: string]: VerticalRhythm };

interface Config {
  fontSize: number
  lineHeight: string
}

export interface VerticalRhythmStrategy {
  fontSize: number
  lineHeight: number
  fontScaleFactor: number
  lineHeightMap: { [key: string]: number }
}

export class VerticalRhythm {
  fontSize: number;

  lineHeight: number;

  fontScaleFactor: number;

  lineHeightMap: { [key: string]: number };

  body: Config;

  h4: Config;

  h3: Config;

  h2: Config;

  h1: Config;

  p: Config;

  span: Config;


  constructor({ fontSize, lineHeight, fontScaleFactor, lineHeightMap }: VerticalRhythmStrategy) {
    this.fontSize = fontSize;
    this.lineHeight = Math.ceil(fontSize * lineHeight);
    this.fontScaleFactor = fontScaleFactor;
    this.lineHeightMap = lineHeightMap;

    this.body = { fontSize, lineHeight: `${this.lineHeight}px` };

    this.h4 = this.body;

    this.h3 = this.scaleUp(this.h4.fontSize, lineHeightMap.h3);

    this.h2 = this.scaleUp(this.h3.fontSize, lineHeightMap.h2);

    this.h1 = this.scaleUp(this.h2.fontSize, lineHeightMap.h1);

    this.p = this.body;

    this.span = this.body;
  }

  scaleUp(fontSize: number, lineHeightMultiplier: number): Config {
    const scaledUpFontSize = Math.round(fontSize * this.fontScaleFactor);
    return {
      fontSize: scaledUpFontSize,
      lineHeight: `${this.lineHeight * lineHeightMultiplier}px`,
    };
  }
}
